import React, { useCallback, useState } from 'react';
import { DiroCalendar } from '../diro-calendar';
import { fetchStudentLecturesOperation } from './operations/fetch-student-lectures-operation';

export const StudentCalendar: React.FC<{ studentId: number }> = ({
  studentId,
}) => {
  const [lectures, setLectures] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const handleRangeChange = useCallback(
    async (startDate: Date, endDate: Date) => {
      await fetchStudentLecturesOperation(
        studentId,
        {
          offset: 0,
          limit: 1000,
          startDate,
          endDate,
        },
        setLoading,
        setLectures,
      );
    },
    [studentId],
  );

  return (
    <DiroCalendar
      data={lectures}
      loading={loading}
      onDateRangeChange={handleRangeChange}
    />
  );
};
